import React from "react";
import { Grid } from "material-ui";
import { Card } from "@material-ui/core";
import { CardHeader } from "material-ui";
import { CardContent } from "material-ui";
import { BarChartLegend } from "./BarChartLegend";
import { BarChart } from "./BarChart";
import { LineChart } from "./LineChart";

export class BarChartCard extends React.Component {
  
  render() {
    const { 
      t,
      i18n,
      classes, 
      chartName,
      loading,
      title,
      subheader,
      avatar,
      unit,
      stacked,
      barChartData,
      currentAssetConsuming,  
      menuComponent,
      type,
      dateDisplayOptions
    } = this.props;
    //if (loading || !barChartData) { return false }
    if (loading) { return false }

    return (
      <Grid item xs={12} sm={12}>
        <Card
          key={`${chartName}-barchart-card`}
          className={classes.card}
        >
          <CardHeader
            key={`${chartName}-barchart-cardheader`}
            avatar={avatar}
            title={title}
            subheader={subheader}
            action={menuComponent}
          />
          <CardContent
            key={`${chartName}-barchart-cardcontent`}
            style={{
              height: barChartData.data.length <= 10 ? 300 : 200 + barChartData.data.length * 10,
              marginBottom: barChartData.data.length <= 10 ? 25 : 50 + barChartData.data.length * 2
            }}
          >
            
            <BarChartLegend 
              key={`${chartName}-barchart-legend`}
              barChart={this.chart}
              classes={classes} 
              loading={loading}
              barChartData={barChartData}
              currentAssetConsuming={currentAssetConsuming}
            />
            {type === "line" ? (
              <LineChart 
                key={`${chartName}-barchart-chart`}
                ref={ref => { this.chart = ref; }}
                t={t} 
                classes={classes} 
                unit={unit}
                stacked={stacked}
                barChartData={barChartData}
                loading={loading}
                i18n={i18n}
                dateDisplayOptions={dateDisplayOptions}
              />
            ) : (
              <BarChart 
                key={`${chartName}-barchart-chart`}
                ref={ref => { this.chart = ref; }}
                t={t} 
                classes={classes} 
                unit={unit}
                stacked={stacked}
                barChartData={barChartData}
                loading={loading}
                i18n={i18n}
                dateDisplayOptions={dateDisplayOptions}
              />
            )}
          </CardContent>
        </Card>
      </Grid>
    );

    
  }
}


// WEBPACK FOOTER //
// ./src/components/ChartCards/BarChartCard.js